module.exports = __webpack_public_path__ + "static/img/0761.437c3a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0761.jpg
// module id = 100
// module chunks = 0